import { render, staticRenderFns } from "./orderArtical.vue?vue&type=template&id=67a36d4c"
import script from "./orderArtical.vue?vue&type=script&lang=js"
export * from "./orderArtical.vue?vue&type=script&lang=js"
import style0 from "./orderArtical.vue?vue&type=style&index=0&id=67a36d4c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports